import graphql from "babel-plugin-relay/macro";
import { useSetAtom } from "jotai";
import _ from "lodash";
import { useEffect } from "react";
import { useFragment } from "react-relay";

import { useInitEventSignUpPrimaryChargeInfo_event$key } from "./__generated__/useInitEventSignUpPrimaryChargeInfo_event.graphql";
import { primaryChargeRulePriceAtom } from "./groupEvent";

export const useInitEventSignUpPrimaryChargeInfo = ({
  eventRef,
}: {
  eventRef: useInitEventSignUpPrimaryChargeInfo_event$key;
}) => {
  const event = useFragment(
    useInitEventSignUpPrimaryChargeInfoFragmentString,
    eventRef
  );

  const isGroupEvent =
    event?.maxGuestCount !== 0 ||
    event?.maxMemberCount !== 1 ||
    event?.minMemberCount !== 1 ||
    event?.minGuestCount !== 0;

  const setPrimaryChargeRulePrice = useSetAtom(primaryChargeRulePriceAtom);

  const shouldShowPrimaryChargeWhoPays =
    event.primaryChargeType === "PER_PERSON" && isGroupEvent;

  const chargeRuleSet =
    event.primaryRegistrationChargeTypes?.edges?.[0]?.node?.chargeRuleSet;

  const chargePrice = chargeRuleSet?.chargeRules?.edges?.[0]?.node?.price;

  /**
   * Currently we show the screen to select primary charge payers IF we
   * have a primary charge rule present and it's a group event. (solo events obviously you pay for yourself)
   *
   * This will be temporary as we'll need to expand this to accomodate more complicated charge patterns
   */
  useEffect(() => {
    if (shouldShowPrimaryChargeWhoPays && _.isNumber(chargePrice)) {
      setPrimaryChargeRulePrice(chargePrice);
    } else {
      setPrimaryChargeRulePrice(null);
    }
  }, [chargePrice, setPrimaryChargeRulePrice, shouldShowPrimaryChargeWhoPays]);
};

export const useInitEventSignUpPrimaryChargeInfoFragmentString = graphql`
  fragment useInitEventSignUpPrimaryChargeInfo_event on Event {
    maxMemberCount
    minMemberCount
    maxGuestCount
    minGuestCount
    primaryChargeType
    primaryRegistrationChargeTypes {
      edges {
        node {
          chargeRuleSet {
            id
            displayName
            displayDescription
            chargeRules {
              edges {
                node {
                  id
                  duration
                  price
                  billingId
                  description
                }
              }
            }
          }
        }
      }
    }
  }
`;
